<template>
  <!-- 典型案例 -->
  <div :class="isPcFlag ? 'typical-cases-pc' : 'typical-cases-h5'">
    <div class="content">
      <div class="title">典型案例</div>
      <div class="card-box">
        <img class="img" :src="item.img" alt="" v-for="(item, index) in list" :key="index" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isPcFlag: Boolean, // 是Pc还是H5
    list: {
      type: Array,
      default: [],
    },
  },
}
</script>

<style lang="less" scoped>
.basisDisplay(@justify,@align) {
  display: flex;
  justify-content: @justify;
  align-items: @align;
}
.columnDisplay(@justify,@align) {
  display: flex;
  flex-direction: column;
  justify-content: @justify;
  align-items: @align;
}
.typical-cases-pc {
  width: 100%;
  background: #f8f9fb;
  padding: 72px 0;
  .content {
    max-width: 1320px;
    height: 100%;
    margin: 0 auto;
    .columnDisplay(flex-start,center);
    .title {
      margin-bottom: 61px;
      font-size: 32px;
      font-weight: 600;
      color: rgba(0, 0, 0, 0.85);
    }
    .card-box {
      width: 100%;
      .basisDisplay(center,center);
      .img {
        width: 248px;
        height: 86px;
        margin:18px;
      }
    }
  }
}
.typical-cases-h5 {
  width: 100%;

  background: #f8f9fb;
  padding: 1.0667rem 0;
  .content {
    max-width: 10rem;
    height: 100%;
    margin: 0 auto;
    .columnDisplay(flex-start,center);
    .title {
      margin-bottom: 0.64rem;
      font-size: 0.48rem;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.85);
    }
    .card-box {
      .basisDisplay(center,center);
      flex-wrap: wrap;
      .img {
        width: 3.7333rem;
        height: 1.28rem;
        margin: 0.08rem;
      }
    }
  }
}
</style>